import { PlaylistReport } from "@/components/playlist/PlaylistReport";
import { getOneTimePlays, getPlays } from "@/queries/plays";
import { useReportContext } from "@/stores/ReportContext";

const PlayListAnalytics = () => {
  const { reportId } = useReportContext();

  const { data } = getPlays(reportId, {});
  const { data: oneTimePlaysData } = getOneTimePlays({});
  const plays = [...(data?.plays || []), ...(oneTimePlaysData?.plays || [])];

  return <PlaylistReport plays={plays} />;
};

export default PlayListAnalytics;
